<template>
  <div>
    <b-modal
      id="NewUserModal"
      ref="NewUserModal"
      size="lg"
      content-class="menu-bg-blue-transparent-modal num-modal"
      title="New User"
      hide-footer
     
      @show="initModal()"
    >
      <b-container>
        <b-row v-if="this.user.role != 'USHR Acquisition Admin'">
          <b-col class="py-2">
            <a href="#" class="link-primary float-right" @click="back()">
              Back To User Accounts
            </a>
          </b-col>
        </b-row>

        <b-container class="menu-bg-blue-transparent">
          <b-row class="py-2">
            <b-col class="col-sm-12 px-5">
              <div class="field px-5">
                <label for="name">Name *</label>
                <b-form-input
                  name="name"
                  placeholder="Name"
                  autocomplete="off"
                  v-model="form.name"
                />
              </div>
            </b-col>
          </b-row>
          <b-row class="py-2">
            <b-col class="col-sm-12 px-5">
              <div class="field px-5">
                <label for="email">Email *</label>
                <b-form-input
                  name="email"
                  placeholder="Email"
                  autocomplete="off"
                  v-model="form.email"
                />
              </div>
            </b-col>
          </b-row>
          <b-row class="py-2">
            <b-col class="col-sm-12 px-5">
              <div class="field px-5">
                <label>Organization *</label>
                <b-form-select v-model="form.org">
                  <option
                    v-for="org in this.organizations"
                    :key="org.id"
                    :value="org.id"
                  >
                    {{ org.company_name }}
                  </option>
                </b-form-select>
              </div>
            </b-col>
          </b-row>
          <b-row class="py-2">
            <b-col class="col-sm-12 px-5">
              <div class="field px-5">
                <label>Authorization *</label>
                <b-form-select v-model="form.authorization">
                  <option
                    v-for="obj in this.permissions"
                    :key="obj.id"
                    :value="obj"
                  >
                    {{ obj.role_name }}
                  </option>
                </b-form-select>
              </div>
            </b-col>
          </b-row>
          <!-- Group field -->
          <b-row class="py-2">
            <b-col class="col-sm-12 px-5">
              <div class="field px-5">
                <label>Group * </label>
                <!-- <select class="custom-select">
                  <option
                    v-for="item in groups"
                    :selected="item.group_name === 'None'"
                    :key="item.id"
                  >
                    {{ item.group_name }}
                  </option>
                </select> -->
                <b-form-select v-model="form.group">
                  <option
                    v-for="item in groups"
                    :key="item.id"
                    :value="item.group_name"
                  >
                    {{ item.group_name }}
                  </option>
                </b-form-select>
              </div>
            </b-col>
          </b-row>
          <b-row class="py-2">
            <b-col class="col-sm-12 px-5">
              <div class="field px-5">
                <label>Password *</label>
                <b-row>
                  <b-col>
                    <b-form-input
                      type="text"
                      name="password"
                      placeholder="Password"
                      autocomplete="off"
                      v-model="form.password"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="p-2">
            <b-col class="text-center">
              <span class="ml-1">
                Note: This is an automated password and can be edited. Please copy
                before submitting!
              </span>
            </b-col>
          </b-row>
          <b-row class="py-2" v-if="this.user.role != 'USHR Acquisition Admin'">
            <b-col class="col-sm-12 px-5">
              <div class="field px-5">
                <!-- Disable checkbox if updating user, enable if adding user -->
                <b-form-checkbox v-model="form.testAccount" value="True" unchecked-value="False">Test Account</b-form-checkbox>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <b-row id="feedbackWindow" class="p-2" v-if="feedback">
          <b-col class="text-center">
            <span class="ml-1">
              <b class="alert alert-danger">{{ this.feedback }}</b>

              <fa :icon="['fas', 'window-close']" @click="feedbackHide()" />
            </span>
          </b-col>
        </b-row>

        <b-container v-if="formSubmitErrors.length">
          <b-col class="text-center">
            <span>
              <b>Please correct the following error(s):</b>
              <b-list-group>
                <div v-for="error in formSubmitErrors" :key="error" class="my-2">
                  <b-list-group-item variant="danger">{{
                    error
                  }}</b-list-group-item>
                </div>
              </b-list-group>
            </span>
          </b-col>
        </b-container>

        <b-row id="submitSuccessWindow" class="p-2" v-if="submitSuccess">
          <b-col class="text-center">
            <span class="ml-3">
              <b class="alert alert-success">{{ this.submitSuccess }}</b>
              <fa :icon="['fas', 'window-close']" @click="submitSuccessHide()" />
            </span>
          </b-col>
        </b-row>

        <!-- Only shows when adding a user -->
        <b-row class="p-3">
          <b-col class="text-center">
            <b-button
              class="btn-lg float-right"
              variant="primary"
              type="submit"
              @click="checkForm()"
            >
              Submit
            </b-button>
          </b-col>
          <b-col class="text-center">
            <b-button
              class="btn-lg float-left"
              variant="secondary"
              type="button"
              @click="clearForm()"
            >
              Clear
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<style>
.num-modal .menu-bg-blue-transparent,
.num-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.num-modal label { color: rgba(6, 60, 109, 0.7); }
.num-modal .form-control {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}
.num-modal .form-control::placeholder { color: rgba(6, 60, 109, 0.35); }
.num-modal .form-control:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}
.num-modal .link-primary { color: #063c6d !important; }
</style>

<script>
import axios from 'axios'
import new_user from '!!raw-loader!../../../emails/new_user.html'
import { generateSecureString } from '../../../utils/utils'
export default {
  name: 'MMP_NewUserModal',
  components: {},
  props: ['user'],
  data() {
    return {
      formSubmitErrors: [],
      form: {
        name: null,
        email: null,
        password: null,
        org: null,
        authorization: [],
        group: null,
        testAccount: 'False'
      },
      groups: [],
      permissions: [],
      randomPassword: null,
      organizations: [],
      deletedFeedback: null,
      feedback: null,
      submitSuccess: '',
      spinner: false,
      usersRows: [],
      email_recipients: [],
      tutorialsJSON: {}
    }
  },
  methods: {
    initModal() {
      this.getCompanies()
      this.getGroups()
      this.generatePassword()
      this.getRoles()
      this.getTutorials()
    },
    getTutorials() {
      if (sessionStorage.token) {
        axios
        .get(process.env.API_LOCATION + '/api/tutorial/getAllTutorials', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getAllTutorials API Call Error: ' + content.errors)
            } else {
              this.tutorialsJSON = Object.fromEntries(
                content.map(item => [item.name, false])
              );
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getRoles() {
      if (sessionStorage.token) {
        axios.get(process.env.API_LOCATION + '/api/users/activeRoles',
            {
                headers: {
                    'x-auth-token': sessionStorage.token
                },
            }
        ).then(response => {
            const content = response.data
            if (content.errors) {
                console.log(content.errors)
            } else {
                this.permissions = content.rows
            }
        })
        .catch(function (error) {
            console.log(error)
        })
      } else {
        console.log('No User Token')
      }
    },
    checkForm: function () {
      this.formSubmitErrors = []

      if (!this.form.name) {
        this.formSubmitErrors.push('User Name is required.')
      }
      if (!this.form.email) {
        this.formSubmitErrors.push('User Email is required.')
      }
      if (!this.form.org) {
        this.formSubmitErrors.push('Organization is required.')
      }
      if (!this.form.authorization) {
        this.formSubmitErrors.push('Authorization is required.')
      }
      if (!this.form.password) {
        this.formSubmitErrors.push('Password is required.')
      }
      if (this.form.password && this.form.password.length < 6) {
        this.formSubmitErrors.push(
          'Please enter a password with 6 or more characters.'
        )
      }
      if (!this.formSubmitErrors.length) {
        this.checkDuplicateUser()
      }
    },
    clearForm() {
      this.form = {
        name: null,
        email: null,
        password: null,
        org: null,
        authorization: null,
        testAccount: 'False'
      }
      this.formSubmitErrors = []
      this.feedback = null
      this.generatePassword()
    },
    loadUsers() {
      this.spinner = true // not declared, not used -- added anyway.
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/users', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              active: this.activeChk,
              inactive: this.inactiveChk
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Users API Call Error: ' + content.errors)
            } else {
              this.usersRows = content.rows // not declared, not used -- added anyway.
              this.spinner = false // not declared, not used -- added anyway.
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getGroups() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/groups', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Groups API Call Error: ' + content.errors)
            } else {
              this.groups = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    back() {
      this.$bvModal.hide('NewUserModal')
      if (this.user.role != 'USHR Acquisition Admin') {
        this.loadUsers()
        this.$bvModal.show('UACModal')
      }
    },
    checkDuplicateUser() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/checkUser', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: this.form.email
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('checkUser API Call Error: ' + content.errors)
            } else {
              if (content.length > 0) {
                this.formSubmitErrors.push('User already exists!')
              } else {
                this.submitForm()
              }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async submitForm() {
      let authWorkaroundObj = {
        permissions: this.form.authorization.role_name,
        testAccount: this.form.testAccount,
        group: this.form.group
      }

      this.submitSuccessHide()
      this.feedbackHide()
      let name = JSON.stringify(this.form.name)
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/users/addUser', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': sessionStorage.token
            },
            params: {
              name: this.form.name,
              email: this.form.email.replace(/\s/g, ''),
              password: this.form.password.replace(/\s/g, ''),
              org: this.form.org,
              authorization: authWorkaroundObj,
              user_role_id: this.form.authorization.id,
              tutorials: JSON.stringify(this.tutorialsJSON)
            }
          })
          .then(async (response) => {
            const content = response.data
            if (!content.errors) {
              this.submitSuccess = 'User account for ' + name + ' is created.'
              if (authWorkaroundObj.permissions == 'USHR Operator') {
                axios
                  .get(process.env.API_LOCATION + '/api/dpr/newOperator', {
                    headers: {
                      'x-auth-token': sessionStorage.token
                    },
                    params: {
                      newOperatorName: content.name,
                      userid: content.id
                    }
                  })
                  .catch(function (error) {
                    console.log(error)
                  })
              }
              await this.sendConfirmationEmail();
              this.clearForm();
            } else {
              console.log('addUser API Call Error: ' + content.errors)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
        this.clearForm()
      }
      this.loadUsers()
    },
    submitSuccessHide() {
      this.submitSuccess = ''
    },
    feedbackHide() {
      this.feedback = ''
    },
    // REFACTOR SUGGESTION - this fn is never used.
    deletedFeedbackHide() {
      this.deletedFeedback = ''
    },
    getCompanies() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/company/', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Companies API Call Error: ' + content.errors)
            } else {
              this.organizations = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    generatePassword() {     
      let retVal = generateSecureString(8)

      this.randomPassword = retVal
      this.form.password = retVal
    },
    async resetUACforAcquisitionAdmin() {
      if (this.user.role == 'USHR Acquisition Admin') {
        this.clearForm()
        this.permissions = []
        this.permissions = [
          {perm: {permissions: 'USHR Operator'}, name: 'USHR Operator'}
        ]
        await this.$nextTick()
      }
    },
    sendConfirmationEmail() {      
      let name = this.form.name
      let email = this.form.email.replace(/\s/g, '')
      let password = this.form.password.replace(/\s/g, '')

      const fromEmail = 'mmp-info@dmp-maps.com'
      const toEmail = [email]
      // const toEmail = ['nschweikhart@dmp-maps.com']
      const emailSubject = 'Your account has been created on Map Management Platform'
      const isValidEmail = (email !== null && password !== null)

      let year = new Date().getFullYear()

      const emailBody = new_user
              .replace('{{ name }}', name)
              .replace('{{ email }}', email)
              .replace('{{ password }}', password)
              .replace('{{ year }}', year)

      if (sessionStorage.token) {
          if (isValidEmail) {
            axios.post(
                process.env.API_LOCATION + '/api/email/sendemail',
                {
                    fromEmail: fromEmail,
                    toEmail: toEmail,
                    emailSubject: emailSubject,
                    emailBody: emailBody
                },
                {
                    headers: {
                        'x-auth-token': sessionStorage.token
                    }
                }
            ).then(response => {
                  const content = response.data
                  this.$bvModal.hide('NewUserModal')
                  if (content.errors) {
                    console.log('sendConfirmationEmail API Call Error')
                    console.log(content.errors)
                    return
                  } else {
                    if (content.some(obj => obj.status !== 'bounced' || obj.status !== 'rejected')) {
                      this.$bvToast.toast('User Account confirmation Email sent.', {
                        autoHideDelay: 5000,
                        variant: 'success',
                        solid: true,
                        title: 'Email Sent',
                        toaster: 'b-toaster-top-center'
                      })
                    }                                
                  }
              })
              .catch(function (error) {
                  console.log(error)
                  self.feedback = error.response.data.errors[0].msg
                  self.showFeedback()
              })
          } else {
            this.$bvToast.toast('Error sending email. Email address or password missing.', {
                autoHideDelay: 7000,
                variant: 'danger',
                solid: true,
                title: 'Email Not Sent',
                toaster: 'b-toaster-top-center'
            })
            return
          }
      }
      else {
          console.log("No User Token")
          this.$router.push({ name: 'Login' })
      }
    }
  }
}
</script>
